import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import cmsPageAPI from "../../api/cmsPageApi";
import SEO from "../../components/SEO";
import Breadcrump from "../../components/Breadcrump";

function TermsofServices() {
  const location = useLocation();
  const path = location.pathname.split("/")[1];

  const [metaData, setMetaData] = useState({});
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");

  useEffect(() => {
    fetchCMSDetails();
  }, [path]);

  const fetchCMSDetails = async () => {
    try {
      const res = await cmsPageAPI.details(path);

      if (res.code === 200) {
        const result = res.data;

        setTitle(result.title);
        setDescription(result.content);
        setMetaData(result?.meta);
      }
    } catch (err) {
      console.error("Error fetching CMS content:", err);
    }
  };

  return (
    <>
      <SEO meta={metaData} />

      <Breadcrump title={title} />

      {/* 🔥 FIXED: Class framework changed to hook premium corporate layout rules */}
      <section className="cms-legal-page-funky py-5">
        <div className="container">
          <div className="cms-card-wrapper-brutal p-4 p-md-5">
            <div className="cms-html-content-render">
              <div dangerouslySetInnerHTML={{ __html: description }} />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default TermsofServices;